import { render, staticRenderFns } from "./PermittedFunctionEdit.vue?vue&type=template&id=42f45388&scoped=true&lang=pug"
import script from "./PermittedFunctionEdit.vue?vue&type=script&lang=ts"
export * from "./PermittedFunctionEdit.vue?vue&type=script&lang=ts"
import style0 from "./PermittedFunctionEdit.vue?vue&type=style&index=0&id=42f45388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f45388",
  null
  
)

export default component.exports